import { toEnglishDigits } from 'utilities/helper/toEnglishNumber'

export type TShareInput =
    | { ok: true; value: number }
    | { ok: false; reason: 'empty' | 'invalid' | 'unchanged' }

export const SHARE_INPUT_ERROR: { [reason: string]: string } = {
    empty: 'تعداد سهم را وارد کنید',
    invalid: 'تعداد سهم باید یک عدد صحیح و نامنفی باشد',
}

/**
 * What the «تعداد سهم» box actually asked for.
 *
 * The modal used to send `Number(value)` as typed. That was wrong three ways,
 * and since pwa#135 every one of them would also have written a line in the
 * member's تاریخچهٔ تعداد سهم:
 *   * an empty box is `Number('') === 0` — tapping «تایید» without typing
 *     set the member to ZERO shares;
 *   * «۴» from a Persian keyboard is `NaN`, which JSON sends as null, which
 *     the backend used to 500 on halfway through the write;
 *   * re-confirming the count the member already has opened a new Share row
 *     for nothing, which moves where the NEXT real change lands.
 *
 * `current` is the count the list showed; an unchanged value is not sent.
 */
export function parseShareInput(
    raw: string,
    current: number | undefined
): TShareInput {
    const text = toEnglishDigits(raw ?? '').trim()
    if (!text) return { ok: false, reason: 'empty' }
    if (!/^\d+$/.test(text)) return { ok: false, reason: 'invalid' }
    const value = Number(text)
    if (!Number.isSafeInteger(value)) return { ok: false, reason: 'invalid' }
    if (current != null && value === Number(current)) {
        return { ok: false, reason: 'unchanged' }
    }
    return { ok: true, value }
}
